'use strict';

/**
 * Does a quick comparison to the current value and changes the input if different.
 * 
 */

module.exports = function($) {

  $.fn.swVal = function(value) {
    var $this = $(this);
    var currentValue = $this.val();

    if (!value) {
      return currentValue;
    }

    if (currentValue !== value) {
      return $this.val(value).change();
    }

    return $this;
  };

};
